module.exports = __webpack_public_path__ + "img/mainPicture.ca394579.png";